import styled from 'styled-components';

export const ModalActionButtons = styled.div`
  align-items: center;
  display: flex;
  margin-top: 1rem;

  .ant-btn:first-child {
    margin-left: auto;
  }

  .ant-btn:not(:first-child) {
    margin-left: 0.5rem;
  }
`;
